let checkoutLoader;

export const loadRazorpayCheckout = () => {
  if (window.Razorpay) return Promise.resolve(true);
  if (checkoutLoader) return checkoutLoader;

  checkoutLoader = new Promise((resolve, reject) => {
    const existing = document.getElementById('razorpay-checkout-script');
    const script = existing || document.createElement('script');
    const fail = (message) => {
      checkoutLoader = null;
      script.remove();
      reject(new Error(message));
    };
    const timeout = window.setTimeout(() => fail('Razorpay Checkout timed out'), 10000);
    const finish = () => {
      window.clearTimeout(timeout);
      if (window.Razorpay) resolve(true);
      else fail('Razorpay Checkout did not initialize');
    };
    script.addEventListener('load', finish, { once: true });
    script.addEventListener('error', () => {
      window.clearTimeout(timeout);
      fail('Razorpay Checkout could not load');
    }, { once: true });
    if (!existing) {
      script.id = 'razorpay-checkout-script';
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.async = true;
      document.body.appendChild(script);
    }
  });
  return checkoutLoader;
};